var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-full h-full flex items-center justify-center"},[_c('div',{staticClass:"driveuploader-replace"}),(!_vm.rallyRound.driveUploaderLink && _vm.rallyRound.id)?_c('div',{staticClass:"text-white"},[_vm._v(" Der Rodeo Upload ist zurzeit deaktiviert, bitte komm später vorbei! ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }